import styled, { css } from "styled-components";
import { TableContainer } from "@mui/material";

import StyledTableCell from "./StyledTableCell";

interface StyledTableContainerProps {
    $condensed?: boolean;
}

const StyledTableContainer = styled(TableContainer)<StyledTableContainerProps>`
    ${(props) =>
        props.$condensed &&
        css`
            ${StyledTableCell} {
                padding-top: 0;
                padding-bottom: 0;
                padding-right: 0;
                padding-left: 16px;
                &:last-child {
                    padding-right: 16px;
                }
            }
            .headerCell {
                white-space: initial;
                text-overflow: initial;
                overflow: initial;
                padding-right: 0;
                padding-left: 16px;
                &:last-child {
                    padding-right: 16px;
                }
            }
        `};
`;

StyledTableContainer.defaultProps = {
    $condensed: false,
};

export default StyledTableContainer;
